import exampleThumbnail from '../../../../../../assets/registration/example-thumbnail.png';
import descriptionExample from '../../../../../../assets/registration/description-example.png';

import {
  Container,
  BlankLayer,
  GrayLayer,
  Row,
  Name,
  Description,
  Informations,
} from './styles';

const CellPhoneThumbnail = ({
  thumbnail = exampleThumbnail,
  name = '',
  description = '',
  thumbPreview,
}) => {
  return (
    <Container>
      <BlankLayer>
        <GrayLayer>
          <Row>
            <img
              src={thumbPreview || thumbnail}
              alt="Imagem que representa um exemplo de thumbnail"
            />
            <Informations>
              <Name>{name}</Name>
              <Description>{description}</Description>
            </Informations>
          </Row>
          <Row>
            <img
              src={exampleThumbnail}
              alt="Imagem que representa um exemplo de thumbnail"
            />
            <img
              src={descriptionExample}
              alt="Imagem que representa um exemplo de descrição"
            />
          </Row>
          <Row>
            <img
              src={exampleThumbnail}
              alt="Imagem que representa um exemplo de thumbnail"
            />
            <img
              src={descriptionExample}
              alt="Imagem que representa um exemplo de descrição"
            />
          </Row>
          <Row>
            <img
              src={exampleThumbnail}
              alt="Imagem que representa um exemplo de thumbnail"
            />
            <img
              src={descriptionExample}
              alt="Imagem que representa um exemplo de descrição"
            />
          </Row>
        </GrayLayer>
      </BlankLayer>
    </Container>
  );
};

export default CellPhoneThumbnail;
